import React from 'react';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextAlign,
    availableTextDecoration,
    availableLineHeight,
    availableBorderWidth,
    availableBorderStyle
} from '../../constants/availableFonts';

const calendarStoreDefaults = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign,
    availableBorderWidth: availableBorderWidth,
    availableBorderStyle: availableBorderStyle
};

const calendarReducer = (state = calendarStoreDefaults, action) => {
    return state;
};

export default calendarReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/calendar.js